import React from 'react';
import System from 'src/helper/system';

const EditQtyMsg = (props) => {
    const { single_product_pricing_list } = props
    return (
        <>
            {single_product_pricing_list[0] && System.checkIsEnableQuantity(single_product_pricing_list) &&
                <div className='unit-price-box'>
                    Unit price can vary with<br></br>Quantity entered.
                </div>
            }
        </>
    );
}

export default EditQtyMsg;